import './textHTML.scss';

import * as DOMPurify from 'dompurify';

interface Props {
  /** HTML description */
  text: string;
}

const TextHTML = ({ text }: Props) => {
  const sanitizedText = DOMPurify.default.sanitize(text);

  if (!sanitizedText) {
    return null;
  }

  return (
    <div
      className='TextHTML'
      data-testid='text-html'
      dangerouslySetInnerHTML={{ __html: sanitizedText }}
    />
  );
};

export default TextHTML;
